(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["complementary_products"] && !window.DesignMode) return;
  try {
    
	const handleIntersection = (entries, observer) => {
		if (!entries[0].isIntersecting) return;
		
		observer.unobserve(productRecommendationsSection);
		const url = productRecommendationsSection.dataset.url;
		
		fetch(url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('.complementary-products');
				
				if (recommendations && recommendations.innerHTML.trim().length) {
					productRecommendationsSection.innerHTML = recommendations.innerHTML;
				}
			})
			.catch(e => {
				console.error(e);
			});
	};
	
	const productRecommendationsSection = document.querySelector('.complementary-products');
	const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 0px 0px'});
	
	observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-related"] && !window.DesignMode) return;
  try {
    
	const handleIntersection = (entries, observer) => {
		if (!entries[0].isIntersecting) return;
		
		observer.unobserve(productRecommendationsSection);
		const url = productRecommendationsSection.dataset.url;
		
		fetch(url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('.product-recommendations-related');
				
				if (recommendations && recommendations.innerHTML.trim().length) {
					productRecommendationsSection.innerHTML = recommendations.innerHTML;
				}
			})
			.catch(e => {
				console.error(e);
			});
	};
	
	const productRecommendationsSection = document.querySelector('.product-recommendations-related');
	const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 0px 0px'});
	
	observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
      })();
